import { GenericTable } from "../../../../../../components/GenericTable/GenericTable";
import { PrescriptionsActions } from "../../Prescriptions/PrescriptionsActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { Stack } from "@mui/material";
import { isMobile } from "react-device-detect";
import { NoDataWarning } from "@/components/common";

export function MedicalNotes({
  rowData = [],
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  // Dados já vêm processados e filtrados do componente Documents
  // Apenas define as colunas da tabela
  const coloumns = [
    {
      column: "Medicamentos",
      rowName: "description",
    },
    {
      column: "Profissional",
      rowName: "practitioner",
    },
    {
      column: "Especialidade",
      rowName: "specialty",
    },
    {
      column: "Data",
      rowName: "date",
    },
  ];
  if (isMobile) {
    return (
      <Stack spacing={2}>
        <>
          {rowData && rowData?.length > 0 ? (
            rowData?.map((row: any) => (
              <DocumentCard
                key={row.id}
                title={row.description || "Prescrição Médica"}
                date={row.date}
                practitioner={row.practitioner}
                specialty={row.specialty}
                // status={{
                //   text: "Prescrito",
                //   color: "#4CAF50",
                //   icon: <MedicalServices fontSize="small" />,
                // }}
                actions={
                  <PrescriptionsActions
                    setRefetch={setRefetch}
                    row={row}
                    handleOpen={handleOpen}
                    setBinaryUrl={setBinaryUrl}
                    cardActions
                  />
                }
              />
            ))
          ) : (
            <NoDataWarning />
          )}
        </>
      </Stack>
    );
  }

  return (
    <GenericTable
      tableColumns={coloumns}
      tableRows={rowData}
      actions={(rowData: any) => (
        <PrescriptionsActions
          setRefetch={setRefetch}
          row={rowData}
          handleOpen={handleOpen}
          setBinaryUrl={setBinaryUrl}
        />
      )}
    />
  );
}
